import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../../StateManagement/actions";
import { Checkbox } from "@mui/material";
import { Tooltip as ReactTooltip } from "react-tooltip";

/**
 * Bulk confirmation popup for the Page Locker Access tab.
 * Used for both bulk Approve and bulk Reject flows when multiple rows
 * are selected. The `mode` prop ("approve" | "reject") drives the title,
 * message, and whether the sender notes textarea + notify checkbox are shown.
*/
export default function PageLockerBulkConfirmModal({
  isOpen,
  mode = "approve",
  onClose,
  onConfirm,
  restrictedPageGroups = [],
  orgPageLockerLstPendingRequestAccess = []
}) {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const dispatch = useDispatch();
  const senderNotesRef = useRef();
  const notifyReaderRef = useRef();

  useEffect(() => {
    dispatch(languageChange(localStorage.getItem("language")));
  }, []);
  useEffect(() => {
    if (!isOpen) {
      setSelectedPagesMap({});
      setSearchMap({});
    }
  }, [isOpen]);
  const handleModalClose = () => {
    setSelectedPagesMap({});
    setNotifyReader(false);
    setSearchMap({});
    onClose();
  };
  const [searchMap, setSearchMap] = useState({});
  const [selectedPagesMap, setSelectedPagesMap] = useState({});
  const isApprove = mode === "approve";
  const [notifyReader, setNotifyReader] = useState(false);
  // const hasLevel1ApprovedPages = orgPageLockerLstPendingRequestAccess.filter((row) => row.selection).some((row) => row.rpdLevel === "1" && (selectedPagesMap[row.id]?.length || 0) > 0);

  // useEffect(() => {
  //   if (hasLevel1ApprovedPages) {
  //     setNotifyReader(true);
  //   }
  //   else {
  //     setNotifyReader(false);
  //   }
  // }, [hasLevel1ApprovedPages]);
  if (!isOpen) return null;

  const title = isApprove
    ? selectedLanguage.LstLanguageCodes.UI_Confirmation || "Confirmation"
    : selectedLanguage.LstLanguageCodes.UI_Confirmation || "Confirmation";

  const primaryMessage = isApprove
    ? "Are you sure you want to approve access to all the selected requests?"
    : "Are you sure you want to decline access to all the selected requests?";

  const secondaryMessage =
    "If you want to review requested pages, please click on the individual row wise.";

  const selectedRequests = orgPageLockerLstPendingRequestAccess.filter((row) => row.selection);
  const allRequestsAreL1 = selectedRequests.length > 0 && selectedRequests.every((req) => req.rpdLevel === "1");

  // const handleContinue = (e) => {
  //   const senderNotes = senderNotesRef.current?.value?.trim() || "";
  //   const notifyReader = notifyReaderRef.current && notifyReaderRef.current.checked ? true : false;
  //   const notifyReaderValue = allRequestsAreL1 ? true : notifyReader;
  //   const requestedDetails = orgPageLockerLstPendingRequestAccess.filter((row) => row.selection);
  //   // onConfirm({ senderNotes, notifyReader: notifyReaderValue, mode, selectedPagesMap, requestedDetails });
  //   // setSelectedPagesMap({});
  //   // setSearchMap({});
  // };
  const handleContinue = () => {
    const senderNotes = senderNotesRef.current?.value?.trim() || "";
    const notifyReader = notifyReaderRef.current?.checked || false;
    const requestedDetails = orgPageLockerLstPendingRequestAccess.filter((row) => row.selection).map((row) => ({
      ...row,
      notifyReader: row.rpdLevel === "1" ? true : notifyReader
    }));
    onConfirm({ senderNotes, mode, selectedPagesMap, requestedDetails });
    setSelectedPagesMap({});
    setSearchMap({});
    setNotifyReader(false);
  };
  const handleTextAreaChange = (e) => {
    let value = e.target.value;
    value = value.replace(/^\s+/, "");
    value = value.replace(/\s{2,}/g, " ");
    if (value.length > 255) {
      value = value.slice(0, 255);
    }
    e.target.value = value;
  };
  const hasSelectedPages = Object.values(selectedPagesMap).some((pages) => pages.length > 0);

  const onSearchHandler = (e, requestId) => {
    const value = e.target.value.replace(/\D/g, "");

    setSearchMap((prev) => ({
      ...prev,
      [requestId]: value,
    }));
  };

  const selectPageHandler = (page, requestId) => {

    setSelectedPagesMap((prev) => {

      const existing = prev[requestId] || [];

      return {
        ...prev,

        [requestId]: existing.includes(page)
          ? existing.filter((p) => p !== page)
          : [...existing, page],
      };
    });
  };

  const selectAllHandler = (
    e,
    requestId,
    filteredPages
  ) => {

    setSelectedPagesMap((prev) => ({
      ...prev,

      [requestId]: e.target.checked
        ? filteredPages
        : [],
    }));
  };

  return (
    <div className="plbm-modal-overlay">
      <div className="modal-dialog modal-dialog-centered modal-customelg">
        <div className="modal-content modal-width">
          <div className="modal-header pb-2">
            <h5 className="Rreply-text">
              Review Request(s)
            </h5>
            <button type="button" className="btn btn-outline-danger modalclose rpdclose" onClick={handleModalClose}>
              <span className="material-icons font-20">highlight_off</span>
            </button>
          </div>

          <div className="rpdFont modal-body">
            <div className="pl-modal-content-wrapper">
              <div className="pl-locked-pages-wrapper">
                {orgPageLockerLstPendingRequestAccess.filter((row) => row.selection).length > 0 ? (
                  orgPageLockerLstPendingRequestAccess.filter((row) => row.selection).map((row, groupIndex) => {
                    // let pages = [];
                    // if (row.status === "Partially Approved") {
                    //   pages = (row.requestedPages || []).filter((p) => !(row.approvedPages || []).includes(p));
                    // } else if (row.status === "Partially Declined") {
                    //   pages = (row.requestedPages || []).filter((p) => !(row.rejectedPages || []).includes(p));
                    // } else {
                    //   pages = row.requestedPages || [];
                    // }
                    const currentGroup = restrictedPageGroups.find(
                      (g) => g.requestId === row.id
                    );

                    const pages = currentGroup?.pages || [];
                    const filteredPages = pages.filter((p) => p.toString().includes(searchMap[row.id] || ""))?.sort((a, b) => a - b);
                    return (
                      <div className="pl-document-card" key={row.id || groupIndex} >
                        <div className="pl-document-header">
                          <div className="pl-document-id">
                            <span className="pl-tooltip-label"> {selectedLanguage.LstLanguageCodes.UI_DocumentID} :  </span>
                            <span>{row.documentId}</span>
                            <span className="material-icons plbm-info-icon" id={`plbmDocInfo_${row.id}`}>
                              info
                            </span>
                            <ReactTooltip className="plbm-tooltip" style={{ opacity: 1 }} anchorId={`plbmDocInfo_${row.id}`} place="bottom">
                              <div className="plbm-tooltip-content">
                                <div className="plbm-tooltip-row flex-wrap Wordbreak">
                                  <span className="pl-tooltip-label"> {selectedLanguage.LstLanguageCodes.UI_DocumentName} :  </span>
                                  <span className="plbm-tooltip-value"> {"     " + row.documentName || "-"} </span>
                                </div>
                                {row.subject && (
                                  <div className="plbm-tooltip-row flex-wrap Wordbreak">
                                    <span className="pl-tooltip-label"> {selectedLanguage.LstLanguageCodes.UI_Subject} : </span>
                                    <span className="plbm-tooltip-value"> {row.subject || "-"} </span>
                                  </div>
                                )}
                              </div>
                            </ReactTooltip>
                          </div>
                          <div className="pl-page-count"></div>
                        </div>
                        <div className="table-toolbar">
                          <div className="select-all">
                            <input type="checkbox" className="pl-checkbox"
                              checked={filteredPages.length > 0 && filteredPages.every((p) => (selectedPagesMap[row.id] || []).includes(p))}
                              onChange={(e) => selectAllHandler(e, row.id, filteredPages)}
                            />
                            <span>{selectedLanguage.LstLanguageCodes.UI_SelectAll}</span>
                          </div>
                          <div className="pl-search-box">
                            <span className="search-icon material-icons">
                              search
                            </span>
                            <input type="text" placeholder="Search pages..." value={searchMap[row.id] || ""} onChange={(e) => onSearchHandler(e, row.id)} />
                          </div>
                        </div>
                        <div className="pl-table-container">
                          <table className="pages-table">
                            <tbody>
                              {Array.from({ length: Math.ceil(filteredPages.length / 5), }).map((_, rowIndex) => {
                                const rowItems =
                                  filteredPages.slice(
                                    rowIndex * 5,
                                    rowIndex * 5 + 5
                                  );
                                return (
                                  <tr key={rowIndex}>
                                    {rowItems.map((page) => (
                                      <td className="table-cell" key={page}>
                                        <div className="page-cell">
                                          <input type="checkbox" className="pl-checkbox"
                                            checked={(selectedPagesMap[row.id] || []).includes(page)}
                                            onChange={() => selectPageHandler(page, row.id)}
                                          />
                                          <span>{page}</span>
                                        </div>
                                      </td>
                                    ))}
                                    {Array.from({ length: 5 - rowItems.length, }).map((_, i) => (<td key={i}></td>))}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-center mt-3 mb-2">{selectedLanguage.LstLanguageCodes.UI_NoRestrictedPagesAvailable}</p>
                )}
              </div>
            </div>
            <div class="text-area">
              <textarea class="note-box" ref={senderNotesRef} placeholder="Optional Note" rows="5" maxlength="255" onChange={handleTextAreaChange}></textarea>
            </div>
            {/* <div className="notify-reader"><input ref={notifyReaderRef} type="checkbox" className="pl-checkbox notify" /> Notify Reader</div> */}
            {!allRequestsAreL1 && (<div className="notify-reader">
              <input
                ref={notifyReaderRef}
                type="checkbox"
                className="pl-checkbox notify"
                checked={notifyReader}
                onChange={(e) => setNotifyReader(e.target.checked)}
              />
              Notify Reader
            </div>)}
            <div className="d-flex justify-content-center">
              <button type="button" className="btn btn-primary px-2rem ms-3"
                onClick={handleContinue}
                disabled={(restrictedPageGroups.length === 0 || !hasSelectedPages)}>
                {selectedLanguage.LstLanguageCodes.UI_Submit}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
